module.exports = __webpack_public_path__ + "img/bill-bgc.a7223f73.png";